import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { path } from "@/lib/site";
import type { Lang } from "@/i18n";

type PageKey = "services" | "references" | "about" | "faq" | "tools" | "contact";

export function Breadcrumbs({ lang, current }: { lang: Lang; current: PageKey }) {
  const { t } = useTranslation();
  const home = t("breadcrumb.home");
  const label = t(`nav.${current}`);
  return (
    <nav aria-label="Breadcrumb" className="container-page pt-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground/60">
        <li>
          <Link
            to={path(lang, "home")}
            className="hover:text-foreground hover:underline underline-offset-4"
          >
            {home}
          </Link>
        </li>
        <li aria-hidden>
          <ChevronRight size={12} className="text-foreground/40" />
        </li>
        <li className="text-foreground/85" aria-current="page">
          {label}
        </li>
      </ol>
    </nav>
  );
}